// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file apps.proto (package river, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_protocol } from "./protocol_pb";
/**
 * Describes the file apps.proto.
 */
export const file_apps = /*@__PURE__*/ fileDesc("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", [file_google_protobuf_empty, file_protocol]);
/**
 * Describes the message river.AppSettings.
 * Use `create(AppSettingsSchema)` to create a new message.
 */
export const AppSettingsSchema = /*@__PURE__*/ messageDesc(file_apps, 0);
/**
 * Describes the message river.RegisterRequest.
 * Use `create(RegisterRequestSchema)` to create a new message.
 */
export const RegisterRequestSchema = /*@__PURE__*/ messageDesc(file_apps, 1);
/**
 * Describes the message river.RegisterResponse.
 * Use `create(RegisterResponseSchema)` to create a new message.
 */
export const RegisterResponseSchema = /*@__PURE__*/ messageDesc(file_apps, 2);
/**
 * Describes the message river.RegisterWebhookRequest.
 * Use `create(RegisterWebhookRequestSchema)` to create a new message.
 */
export const RegisterWebhookRequestSchema = /*@__PURE__*/ messageDesc(file_apps, 3);
/**
 * Describes the message river.RegisterWebhookResponse.
 * Use `create(RegisterWebhookResponseSchema)` to create a new message.
 */
export const RegisterWebhookResponseSchema = /*@__PURE__*/ messageDesc(file_apps, 4);
/**
 * Describes the message river.SetAppSettingsRequest.
 * Use `create(SetAppSettingsRequestSchema)` to create a new message.
 */
export const SetAppSettingsRequestSchema = /*@__PURE__*/ messageDesc(file_apps, 5);
/**
 * Describes the message river.SetAppSettingsResponse.
 * Use `create(SetAppSettingsResponseSchema)` to create a new message.
 */
export const SetAppSettingsResponseSchema = /*@__PURE__*/ messageDesc(file_apps, 6);
/**
 * Describes the message river.GetAppSettingsRequest.
 * Use `create(GetAppSettingsRequestSchema)` to create a new message.
 */
export const GetAppSettingsRequestSchema = /*@__PURE__*/ messageDesc(file_apps, 7);
/**
 * Describes the message river.GetAppSettingsResponse.
 * Use `create(GetAppSettingsResponseSchema)` to create a new message.
 */
export const GetAppSettingsResponseSchema = /*@__PURE__*/ messageDesc(file_apps, 8);
/**
 * Describes the message river.RotateSecretRequest.
 * Use `create(RotateSecretRequestSchema)` to create a new message.
 */
export const RotateSecretRequestSchema = /*@__PURE__*/ messageDesc(file_apps, 9);
/**
 * Describes the message river.RotateSecretResponse.
 * Use `create(RotateSecretResponseSchema)` to create a new message.
 */
export const RotateSecretResponseSchema = /*@__PURE__*/ messageDesc(file_apps, 10);
/**
 * Describes the message river.GetStatusRequest.
 * Use `create(GetStatusRequestSchema)` to create a new message.
 */
export const GetStatusRequestSchema = /*@__PURE__*/ messageDesc(file_apps, 11);
/**
 * Describes the message river.GetStatusResponse.
 * Use `create(GetStatusResponseSchema)` to create a new message.
 */
export const GetStatusResponseSchema = /*@__PURE__*/ messageDesc(file_apps, 12);
/**
 * Describes the message river.GetSessionRequest.
 * Use `create(GetSessionRequestSchema)` to create a new message.
 */
export const GetSessionRequestSchema = /*@__PURE__*/ messageDesc(file_apps, 13);
/**
 * Describes the message river.GetSessionResponse.
 * Use `create(GetSessionResponseSchema)` to create a new message.
 */
export const GetSessionResponseSchema = /*@__PURE__*/ messageDesc(file_apps, 14);
/**
 * Describes the message river.EventPayload.
 * Use `create(EventPayloadSchema)` to create a new message.
 */
export const EventPayloadSchema = /*@__PURE__*/ messageDesc(file_apps, 15);
/**
 * Describes the message river.EventPayload.Messages.
 * Use `create(EventPayload_MessagesSchema)` to create a new message.
 */
export const EventPayload_MessagesSchema = /*@__PURE__*/ messageDesc(file_apps, 15, 0);
/**
 * Describes the message river.EventPayload.SolicitKeys.
 * Use `create(EventPayload_SolicitKeysSchema)` to create a new message.
 */
export const EventPayload_SolicitKeysSchema = /*@__PURE__*/ messageDesc(file_apps, 15, 1);
/**
 * Describes the message river.EventsPayload.
 * Use `create(EventsPayloadSchema)` to create a new message.
 */
export const EventsPayloadSchema = /*@__PURE__*/ messageDesc(file_apps, 16);
/**
 * Describes the message river.AppServiceRequest.
 * Use `create(AppServiceRequestSchema)` to create a new message.
 */
export const AppServiceRequestSchema = /*@__PURE__*/ messageDesc(file_apps, 17);
/**
 * Describes the message river.AppServiceResponse.
 * Use `create(AppServiceResponseSchema)` to create a new message.
 */
export const AppServiceResponseSchema = /*@__PURE__*/ messageDesc(file_apps, 18);
/**
 * Describes the message river.AppServiceResponse.InitializeResponse.
 * Use `create(AppServiceResponse_InitializeResponseSchema)` to create a new message.
 */
export const AppServiceResponse_InitializeResponseSchema = /*@__PURE__*/ messageDesc(file_apps, 18, 0);
/**
 * Describes the message river.AppServiceResponse.StatusResponse.
 * Use `create(AppServiceResponse_StatusResponseSchema)` to create a new message.
 */
export const AppServiceResponse_StatusResponseSchema = /*@__PURE__*/ messageDesc(file_apps, 18, 1);
/**
 * ForwardSettingValue is an app-specific setting applied to all space channels the app is a member
 * of. It specifies which messages the app registry service will consider relevant for forwarding to
 * the bot.
 *
 * @generated from enum river.ForwardSettingValue
 */
export var ForwardSettingValue;
(function (ForwardSettingValue) {
    /**
     * FORWARD_SETTING_UNSPECIFIED not set, assumes FORWARD_SETTING_MENTIONS_REPLIES_REACTIONS as the default setting.
     *
     * @generated from enum value: FORWARD_SETTING_UNSPECIFIED = 0;
     */
    ForwardSettingValue[ForwardSettingValue["FORWARD_SETTING_UNSPECIFIED"] = 0] = "FORWARD_SETTING_UNSPECIFIED";
    /**
     * FORWARD_SETTING_ALL_MESSAGES indicates that the app would like all messages forwarded for each channel
     * it is a member of.
     *
     * @generated from enum value: FORWARD_SETTING_ALL_MESSAGES = 1;
     */
    ForwardSettingValue[ForwardSettingValue["FORWARD_SETTING_ALL_MESSAGES"] = 1] = "FORWARD_SETTING_ALL_MESSAGES";
    /**
     * FORWARD_SETTING_MENTIONS_REPLIES_REACTIONS indicates that the app would only like messages forwarded in
     * channels it has membership in if either the app is mentioned, or the message is a direct reply or reaction
     * to it's own post. This is the default.
     *
     * @generated from enum value: FORWARD_SETTING_MENTIONS_REPLIES_REACTIONS = 2;
     */
    ForwardSettingValue[ForwardSettingValue["FORWARD_SETTING_MENTIONS_REPLIES_REACTIONS"] = 2] = "FORWARD_SETTING_MENTIONS_REPLIES_REACTIONS";
    /**
     * SPACE_CHANNEL_SETTING_NO_MESSAGES indicates that the user won't receive notifications of any channel in the space.
     *
     * @generated from enum value: FORWARD_SETTING_NO_MESSAGES = 3;
     */
    ForwardSettingValue[ForwardSettingValue["FORWARD_SETTING_NO_MESSAGES"] = 3] = "FORWARD_SETTING_NO_MESSAGES";
})(ForwardSettingValue || (ForwardSettingValue = {}));
/**
 * Describes the enum river.ForwardSettingValue.
 */
export const ForwardSettingValueSchema = /*@__PURE__*/ enumDesc(file_apps, 0);
/**
 * AppRegistryService allows apps and app owners to register apps, and set app-related preferences for messages added
 * to channels the app has membership in.
 *
 * These functions are all authenticated, with the exception of GetStatus, and require a session token to be passed
 * through the authorization metadata.
 * This session token can be obtained from the AuthenticationService. If the session token is missing or invalid an
 * Err_UNAUTHENTICATED (code=16) is returned.
 *
 * @generated from service river.AppRegistryService
 */
export const AppRegistryService = /*@__PURE__*/ serviceDesc(file_apps, 0);
//# sourceMappingURL=apps_pb.js.map